var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capacity"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5 9.78809C15.9125 9.78809 16.25 9.45059 16.25 9.03809C16.25 8.62559 15.9125 8.28809 15.5 8.28809H14.75V3.78809H15.5C15.9125 3.78809 16.25 3.45059 16.25 3.03809C16.25 2.62559 15.9125 2.28809 15.5 2.28809H3.5C3.0875 2.28809 2.75 2.62559 2.75 3.03809C2.75 3.45059 3.0875 3.78809 3.5 3.78809H4.25V8.28809H3.5C3.0875 8.28809 2.75 8.62559 2.75 9.03809C2.75 9.45059 3.0875 9.78809 3.5 9.78809H4.25V14.2881H3.5C3.0875 14.2881 2.75 14.6256 2.75 15.0381C2.75 15.4506 3.0875 15.7881 3.5 15.7881H15.5C15.9125 15.7881 16.25 15.4506 16.25 15.0381C16.25 14.6256 15.9125 14.2881 15.5 14.2881H14.75V9.78809H15.5Z",
    fill: "#2E4347"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacity);
export default __webpack_public_path__ + "static/media/capacity.f00dfc55478729bfef291aab2abc656c.svg";
export { ForwardRef as ReactComponent };